import {Directive, HostBinding} from '@angular/core';

@Directive({
    selector: '[appSelectPlaceholderOption]',
})
export class AppSelectElementPlaceholderOptionDirective {
    @HostBinding('style.pointer-events')
    styling: string = 'none';
}
